// extracted by mini-css-extract-plugin
export default {"fields":"EditForm_fields__86mbd","resetButton":"EditForm_resetButton__hXcDg"};